import { AnyObject } from '@apeiron/temp'
import queryString, { StringifiableRecord } from 'query-string'
import * as R from 'ramda'
import { useCallback } from 'react'

const useURL = (): Hook => {
  const buildURL = useCallback(
    (domain: string, route: string, query: AnyObject): string => {
      const url = R.isEmpty(domain) ? '' : new URL(route, domain).toString()

      return queryString.stringifyUrl(
        {
          url,
          query: query as StringifiableRecord
        },
        {
          skipNull: true
        }
      )
    },
    []
  )

  return {
    buildURL
  }
}

type Hook = {
  buildURL: (domain: string, route: string, query: AnyObject) => string
}

export default useURL
